import React from 'react'
import './styles.scss'

interface Props {
  text?: string
  source?: string
  alignToText?: boolean
  noSpace?: boolean
  colors?: { main: string; sub: string; cover: string }
}

export const ImageCredits = ({
  text,
  source,
  alignToText,
  noSpace,
  colors = { main: '#000', sub: '#aaa', cover: '#fff' }
}: Props) => (
  <div className={`ImageCredits ${noSpace && 'noSpace'}`}>
    <div className={alignToText ? 'ui text container' : ''}>
      {text && (
        <div className='text' style={{ color: colors.main }}>
          {text}
        </div>
      )}
      {source && (
        <div className='source' style={{ color: colors.sub }}>
          Foto: {source}
        </div>
      )}
    </div>
  </div>
)
